'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter'
        },
        controller: ['$scope', '$routeParams', 'UserService', '$uibModal', 'StatusService', '$utils', '$security', 'Notification', 'ModalService',
            function ($scope, $routeParams, UserService, $modal, StatusService, $utils, $security, Notification, ModalService) {

                $scope.select = select;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.isSelect = isSelect;
                $scope.dblClick = dblClick;
                $scope.refresh = refresh;

                // инициализация
                init();

                // region Function

                function init() {
                    $scope.loading = true;

                    if (!$scope.selectedItem)
                        $scope.selectedItem = {};

                    $scope.columns = [{
                        name: "Код",
                        data: "id"
                    }, {
                        name: "Логин",
                        data: "username"
                    }, {
                        name: "Ф.И.О.",
                        data: "staff.fullName"
                    }, {
                        name: "Должность",
                        data: "staff.position"
                    }, {
                        name: "Организация",
                        data: "staff.org.fullName"
                    }, {
                        name: "Статус",
                        data: "",
                        type: "func",
                        func: getStatusDisplayName
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $security.isAllowWrite('/users'),
                                click: () => UserService.create({
                                    accountNonLocked: true
                                }).result.then((data) => UserService.api.create(null, {"form": data}, (data) => {
                                    $scope.items.push(data._embedded);
                                    $scope.selectedItem = data._embedded;
                                    $scope.refresh();
                                })),
                                disabled: () => false,
                            },
                            edit: {
                                show: () => $security.isAllowWrite('/users'),
                                click: (item) => UserService.edit(item).result.then((data) => UserService.api.update({userId: item.id}, {"form": data}, (data) => {
                                    angular.copy(data._embedded, item);
                                    $scope.selectedItem = data._embedded;
                                    $scope.refresh();
                                })),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            enable: {
                                show: () => isSelected() && $security.isAllowWrite('/users') && (getSelected().enabled && !getSelected().accountNonLocked),
                                click: (item) => UserService.api.enable({userId: item.id}, null, (data) => {
                                    angular.copy(data._embedded, item);
                                    $scope.refresh();
                                    Notification.success({
                                        message: 'Пользователь разблокирован!',
                                    });
                                }),
                                disabled: () => !isSelected() || getSelected().accountNonLocked,
                            },
                            disable: {
                                show: () => isSelected() && $security.isAllowWrite('/users') && (getSelected().enabled && getSelected().accountNonLocked),
                                click: (item) => UserService.api.disable({userId: item.id}, null, (data) => {
                                    angular.copy(data._embedded, item);
                                    $scope.refresh();
                                    Notification.success({
                                        message: 'Пользователь заблокирован!',
                                    });
                                }),
                                disabled: () => !isSelected() || !getSelected().accountNonLocked,
                            },
                            recovery: {
                                show: () => isSelected() && $security.isAllowWrite('/users') && !getSelected().enabled,
                                click: (item) => UserService.api.recovery({userId: item.id}, null, (data) => {
                                    angular.copy(data._embedded, item);
                                    $scope.refresh();
                                    Notification.success({
                                        message: 'Пользователь восстановлен!',
                                    });
                                }),
                                disabled: () => !isSelected() || getSelected().enabled,
                            },
                            remove: {
                                show: () => isSelected() && $security.isAllowWrite('/users') && getSelected().enabled,
                                click: (item) => ModalService.danger({
                                    message: "Запись будет удалена без возможности восстановления! Вы действительно желаете удалить данную запись?",
                                    apply: "Да",
                                    cancel: "Нет"
                                }).result.then(() => UserService.api.delete({userId: item.id}, null, (data) => {
                                    $scope.items.splice($scope.items.indexOf(item), 1);
                                    $scope.refresh();
                                    Notification.success({
                                        message: 'Пользователь удален!',
                                    });
                                }, (error) => {
                                    Notification.warning({
                                        title: "Внимание!",
                                        message: 'Данную запись удалить нельзя,<br />т.к. на нее ссылаются записи других таблиц.',
                                    });
                                })),
                                disabled: () => !isSelected() || !getSelected().enabled,
                            },
                            refresh: {
                                show: () => true,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        }
                    };
                }

                function getStatusDisplayName(item) {
                    if (!item.enabled) {
                        return "Удален";
                    } else if (item.accountNonLocked) {
                        return "Активен";
                    } else {
                        return "Заблокирован";
                    }
                }

                function getFilters() {
                    let filters = [];
                    if (Array.isArray($scope.filters)) {
                        filters = filters.concat($scope.filters);
                    }
                    return filters;
                }

                function getSearchs() {
                    let searchs = [];
                    if ($scope.isSearch) {
                        if ($scope.searching.filter != null && !($scope.searching.filter.length < 1)) {
                            searchs.push("'username':'" + $scope.searching.filter + "'"
                                , "'staff.firstName':'" + $scope.searching.filter + "'"
                                , "'staff.surname':'" + $scope.searching.filter + "'"
                                , "'staff.middleName':'" + $scope.searching.filter + "'"
                                , "'staff.position':'" + $scope.searching.filter + "'");
                        }
                    }
                    return searchs;
                }

                function isSelected() {
                    return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                }

                function equals(i1, i2) {
                    return angular.equals(i1, i2);
                }

                function getSelected() {
                    return $scope.selectedItem;
                }

                function refresh() {
                    $scope.loading = true;
                    UserService.api.get({
                        filters: getFilters(),
                        searchs: getSearchs(),
                        sorts: ['username:ASC'],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size
                    }, (data) => {
                        $scope.items = data._embedded;
                        if ($scope.items.every(i => i.id != $scope.selectedItem.id)) {
                            $scope.selectedItem = {};
                        }
                        if ($scope.pagination.isPaging) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }
                        $scope.loading = false;
                    });
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok();
                            break;
                    }
                }

                function select(item) {
                    if (!$scope.isSelect(item)) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                function getItems() {
                    return $scope.items;
                }

                // endregion

                // region Watcher

                $scope.$watch('filters', function () {
                    $scope.refresh();
                });

                // endregion

            }]
    };
}
